var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 93 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2732 79.2867L82.6381 64.815L82.4568 64.5861C79.9967 60.7196 78.404 56.3008 77.8363 51.7873L74.4459 24.6982C73.3105 15.537 67.7361 7.50414 59.5439 3.21155C55.5148 1.1126 50.9969 0 46.4789 0C41.961 0 37.4352 1.1126 33.4061 3.21155C25.214 7.50414 19.6474 15.537 18.5041 24.6982L15.1216 51.7873C14.5223 56.5217 12.8113 61.1221 10.1779 65.0911L0.716241 79.2867C-0.158959 80.6123 -0.237806 82.2931 0.511239 83.674C1.2524 85.0706 2.6953 85.9386 4.288 85.9386H30.1734C31.3719 93.9872 38.3025 100 46.5026 100C54.7027 100 61.6333 93.9951 62.8318 85.9386H88.7172C90.302 85.9386 91.7528 85.0706 92.4861 83.6818C93.2351 82.2931 93.1642 80.6123 92.2811 79.2867H92.2732ZM38.8702 85.9465H54.0956C53.0154 89.1738 49.9245 91.4464 46.4789 91.4464C43.0333 91.4464 39.9425 89.1738 38.8623 85.9465H38.8702ZM80.659 77.3771H12.2831L17.3056 69.8414C20.6803 64.7676 22.8643 58.8969 23.6212 52.8525L27.0038 25.7634C27.8001 19.3798 31.6794 13.7931 37.3721 10.8104C43.0649 7.83556 49.8694 7.83556 55.5621 10.8104C61.2627 13.801 65.142 19.3877 65.9383 25.7634L69.3209 52.8525C70.0778 58.8969 72.2619 64.7676 75.6365 69.8414L80.659 77.3771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6f7868b18e88bf1af25f369c895c7775.svg";
export { ForwardRef as ReactComponent };